import API, { defaultConfig } from './config';

export const PortfolioChangesAPI = {

    /**
     * Resumo agregado das alterações no período, por entidade / mês de
     * referência / tipo de alteração.
     *
     * As datas filtram o instante da gravação, não o mês de carteira.
     */
    async getChangesSummary(clientId, startDate, endDate) {

        try {

            const response = await API.post('/portfolio_changes/summary', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
            }, defaultConfig);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response?.data
            };
        }
    },

    /**
     * Registros individuais de um grupo do resumo.
     */
    async getChangesDetail(clientId, startDate, endDate, entity, refMonth, refYear, changeType, limit, offset) {

        try {

            const response = await API.post('/portfolio_changes/detail', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                entity: entity,
                ref_month: refMonth,
                ref_year: refYear,
                change_type: changeType,
                limit: limit,
                offset: offset,
            }, defaultConfig);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response?.data
            };
        }
    },
};
